import React, { Component } from 'react'
import Dialog from './../../../modules/Dialog'
import injectStyles from 'react-jss'
import Button from './../../../modules/Button'
import classNames from 'classnames'

const styles = {
  cancelButton: {
    position: 'absolute',
    bottom: 56,
    left: 0,
    right: 0,
    cursor: 'pointer',
  },
  cancelButtonDisabled: {
    color: 'grey',
  },
  button: {
    width: 358,
    height: 42,
    boxSizing: 'border-box',
    fontSize: 14,
    padding: 0,
  },
  input: {
    width: 358,
    height: 42,
    boxSizing: 'border-box',
    paddingLeft: 22,
    paddingRight: 22,
    fontSize: 14,
    color: '#333333',
  },
}

class NewBranchDialog extends Component {

  state = {
    branchName: '',
  };

  componentWillReceiveProps = (newProps) => {
    if (newProps.saving == false && this.props.saving == true){
      this.props.onClose()
    }
  }

  onNewBranchSave = () => {
    const { onCreateBranch, onClose } = this.props
    const { branchName } = this.state
    onCreateBranch(branchName)
    //onClose()
  }

  onBranchChange = e => this.setState({ branchName: e.target.value })

  render = () => {
    const { onClose, saving, classes } = this.props
    const { branchName } = this.state

    return <Dialog
      onCancel={onClose}
      disabled={saving}
    >
      <h3>New Branch</h3>
      <br /><br /><br />
      <input
        placeholder="Branch Name"
        value={branchName}
        onChange={this.onBranchChange}
        disabled={saving}
        className={classes.input}
      />
      <br /><br /><br />
      <Button
        className={classes.button}
        onClick={this.onNewBranchSave}
        disabled={saving}
      >
        {saving ? 'Saving...' : 'Save'}
      </Button>
      <div
        className={classNames({
          [classes.cancelButton]: true,
          [classes.cancelButtonDisabled]: saving,
        })}
        onClick={saving ? null : onClose}
      >Cancel</div>
    </Dialog>
  }
}

export default injectStyles(styles)(NewBranchDialog)



// WEBPACK FOOTER //
// ./src/pages/RepositoryEdit/NewBranchDialog/NewBranchDialog.js